<template>
  <div class="bg_skx">
    <!-- 头部 -->
    <el-container class="container">
      <el-header>
        <div class="header">
          <div class="logo">
            <!-- <img src="@/nav/log.png" height="80px" /> -->
            <div>
              <div class="titlefont">生涯规划</div>
              <div></div>
            </div>
          </div>
          <div class="title_right" style="cursor: pointer;display: none;">
          <div>
            <img src="@/nav/dp.png" />
          </div>
          <a href="http://hagaozhong.com/Home" target="_blank" style="color: white;">
          <div class="title_right_text">基础教育服务平台</div>
          <!-- 综合实践基地认证 -->
          </a>
        </div>
        </div>
        <div class="menu-box1180">
          <!-- 左右两个页面tab -->
           <!-- 离谱的需求，后来人看到此代码，就知道我多生气了，还要兼容移动端，笑死了，路由组件封装我都不想写了，我直接全部cv了，sorry， -->
         <ul class="box1180_ul">
          <li :class="activeIndex==index?'active_li':''"
           v-for="(item,index) in pageData" :key="item.id" @click="activeClick(item,index)"> 
            <span>
              <img class="showImg" :src="item.src"  style="width: 105px; height: 105px;" />
              <img class="noshowImg" :src="item.src1"  style="width: 105px; height: 105px;" />
              {{item.name}}
            </span>
          </li>
         
         </ul>
    
       </div>
      </el-header>
      <modelVue style=""></modelVue>
      <el-main style="overflow: auto; margin-top: -35px; ">
        <div class="conter">
          <div class="contentBox">
 

          <el-form :model="query" size="mini" inline>
            <div class="line_box">
            <!-- 首选科目 -->
            <el-form-item label="年份:"  style="margin-bottom: 10px;display: flex;align-items: center;">
              <el-radio-group v-model="query.year" @change="changeYear">
                <el-radio v-for="item in yearData" :key="item" :label="item">{{ item }}</el-radio>
                <!-- <el-radio :label="'文科'">文科</el-radio> -->
            </el-radio-group>
            </el-form-item>
           
              <el-form-item  label="批次:"  style="display: flex;margin-bottom: 8px;" >
                <!-- <el-input v-model.trim="query.yxmc" clearable/> -->
                <el-radio-group v-model="query.batch">
                  <el-radio :label="''">全部</el-radio>
                  <el-radio v-for="item in pcData" :key="item" :label="item">{{ item }}</el-radio>
                  
              </el-radio-group>
              </el-form-item>
              <el-form-item label="类别:" class="flex_item">
                <el-radio-group v-model="query.type" >
                  <el-radio :label="''">全部</el-radio>
                    <el-radio v-for="item in typeData" :key="item" :label="item">{{ item }}</el-radio>
                    <!-- <el-radio :label="'文科'">文科</el-radio> -->
                </el-radio-group>
                <button type="button" @click="getList" class="button_click" style="margin-left: 10px;"> 搜索</button>
              </el-form-item>
             
             
            </div>
          </el-form>
          <!-- 下面列表 -->
           <div class="line-gray"></div>
           <div class="title_xk" style="
               border-left: 4px solid #409EFF;
                padding-left: 17px;
                margin-bottom: 10px;">
            <!-- {{nowDate}}年拟在豫招生的普通高校专业选考科目要求({{activeName==1?'本科':'专科'}}层次) -->
             省控线
             <span @click="drawer = true" class="block_span" style="color:blue;display:none;">筛选项</span>
           </div>
           <el-table v-loading="loading" :data="tableData" :height="400" border>
            <el-table-column type="index" label="序号" align="center" width="70">
              <template slot-scope="scope">
                {{ (query.page - 1) * query.size + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="类别" prop="TYPE" width="170" />
            <el-table-column label="年份" prop="YEAR" width="170" />
            <el-table-column label="批次" prop="BATCH" width="180" />
            <el-table-column label="分数线" prop="SCORELINE" width="170" />
            <el-table-column label="位次" prop="POSITION" width="180" />
            <el-table-column prop="ZYF" label="专业分"
          /></el-table>
          <el-pagination
            class="pagination_box"
            background
        
            layout="prev, pager, next"
            :page-sizes="[30, 40,50,100]"
            :page-size="30"
            @current-change="changepage"
            :total=query.total>
            </el-pagination>
          </div>
        </div>
      </el-main>
      <el-footer>
        <div class="footer">
          <span style="padding-right: 20px">
            主办: 河南省教育资源保障中心
          </span>
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            style="color: white"
          >
            {{ "豫ICP备2023037172号-1 " }}
          </a>
          ，@copyrigh 2022-2026 All Rights Reserved
          （建议使用谷歌浏览器，使用1920*1024及以上分辨率）
          <a href="http://hagaozhong.com/Home" style="color: white">
            河南基础教育服务平台
          </a>
        </div>
      </el-footer>
      <div class="div_bottom_fixed">
          <div class="box" :class="active_index==index?'active_box_bar':''" v-for="(value,index) in barData" :key="value.id" @click="clickBar(value,index)">
              <!-- <img src="" alt="" width="20px" height="20px"> -->
              <i :class="value.background" style="width: 20px; height: 20px; font-size: 22px;"></i>
              <span style="padding-top: 2px;">{{ value.label }}</span>
          </div>
      </div>
       <!-- 从上往下开的抽屉 -->
      <el-drawer
        :visible.sync="drawer"
        :direction="'ttb'"
        :before-close="handleClose">
        <el-form :model="query" size="mini" inline style="display:block !important;">
           <!-- 首选科目 -->
          <el-form-item label="年份:"  style="margin-bottom: 10px;display: flex;align-items: center;">
            <el-radio-group v-model="query.year" @change="changeYear">
              <el-radio v-for="item in yearData" :key="item" :label="item">{{ item }}</el-radio>
              <!-- <el-radio :label="'文科'">文科</el-radio> -->
          </el-radio-group>
          </el-form-item>
          
            <el-form-item label="批次:" style="display: flex;margin-bottom: 8px;" class="pici_box">
              <!-- <el-input v-model.trim="query.yxmc" clearable/> -->
              <el-radio-group v-model="query.batch">
                <el-radio :label="''">全部</el-radio>
                <el-radio v-for="item in pcData" :key="item" :label="item">{{ item }}</el-radio>
                
            </el-radio-group>
            </el-form-item>
            <el-form-item label="类别:" class="flex_item">
              <el-radio-group v-model="query.type" >
                <el-radio :label="''">全部</el-radio>
                  <el-radio v-for="item in typeData" :key="item" :label="item">{{ item }}</el-radio>
                  <!-- <el-radio :label="'文科'">文科</el-radio> -->
              </el-radio-group>
             
            </el-form-item>
            
        </el-form>
        <button type="button" @click="getList" class="button_click" > 搜索</button>
      </el-drawer>
    </el-container>
  </div>
</template>
<script>
import axios from "axios";
import modelVue from './model.vue';
export default {
  data() {
    return {
      yearData:[],
      drawer:false,
      activeIndex:2,
      barData: [
        {
            id: 1,
            label: '选课要求',
            background: 'el-icon-house',
            route:'/yxcx'
        },
        {
            id: 2,
            label: '一分一段',
            background: 'el-icon-s-data', 
            route:'/yfyd'
        },
        {
            id: 3,
            label: '省控线',
            background: 'el-icon-set-up',
            route:'/skx'
        },
        {
            id: 4,
            label: '院校库',
            background: 'el-icon-s-home', 
            route:'/yxk'
        },
      ],
      active_index:2,//活跃状态底部index
      pageData: [
        {
          id: 1,
          path: '/yxcx',
          name: '选课要求',
            src: require('@/assets/111.png'),
            src1:require('@/assets/1111.png')
        },
        {
          id: 2,
          path: '/yfyd',
          name: '一分一段表',
          src: require('@/assets/222.png'),
          src1:require('@/assets/2222.png')
        },
        {
          id: 3,
          path: '/skx',
          name: '省控线',
          src: require('@/assets/333.png'),
          src1:require('@/assets/3333.png')
        },
        {
          id: 4,
          path: '/yxk',
          name: '院校库',
          src: require('@/assets/444.png'),
          src1:require('@/assets/4444.png')
        },
      ],
      tableData:[],
      activeName: '理科',
      km1: [],
      subjectmax: 2,
      query: {
        page: 1,
        size: 30,
        total: 0,
        year: '',
        type:'',
        batch: '',
        
      },
      loading: false,
      tableData: [],
      nowDate: '',
      pcData: [],
      typeData:[]
    };
  },
  components: {
    modelVue,
  },
async  created() {
    //  获取当前年份
    this.nowDate = new Date().getFullYear()
    this.getYear()
  },
  methods: {
    handleClose(done){
      done();
    },
    // 改变年份获取批次
    changeYear() {
      var apiUrl1='/cjfxapi/Records/GetBatchByYear'
      axios
        .get(apiUrl1, {
          params: {
            year: this.query.year,
          },
        }
      ).then(res => {
        // console.log(res, "res");
        this.pcData=res.data.data
        // 切换年份后,批次修改默认值
        this.query.batch=''
      })
    },
    handleInput(value) {
     
    },
    // 获取年份
    getYear(){
      var apiUrl='/cjfxapi/Records/GetSkxYearAndType'
      axios
        .get(apiUrl, {
        }
      ).then(res=>{
        // console.log(res,"res")
        this.yearData = res.data.data.years
        this.typeData=res.data.data.types
        this.query.year = this.yearData[0]
        // this.query.type = this.typeData[0]
        this.changeYear()
        this.getList()
      })
    },
    clickBar(value,index) {
        this.$router.push(value.route)
    },
    changepage(data) {
      this.query.size=30
      this.query.page = data
      this.getList()
    },
    activeClick(item,index) {
      // this.activeIndex=index
      this.$router.push(item.path)
    },
    // 获取列表数据
    getList() {
      this.loading = true
      this.tableData = []
      // 重组数组传递所选科目
      // let arr = JSON.parse(JSON.stringify(this.km1))
      // let arr1=[]
      // arr.forEach(element => {
      //   arr1.push(element)
      // });
      // arr1.push(this.query.km)
      // console.log(arr1,"arr1.push(element)");
      // this.query.type=this.activeName
      let params1 = JSON.parse((JSON.stringify(this.query)))
      // console.log(params1,"params1");
      
      // params1.km = arr1.join('|')
      // if (this.activeName=='1') {
      //   params1.type=1
      // }else{
      //   params1.type=0
      // }
      // console.log(params,"params");
      // 线上地址
      // var apiUrl = "http://xsgl.jyt.henan.gov.cn/cjfxapi/Records/PublicApplicablemajors";
      // 本地访问
     var apiUrl='/cjfxapi/Records/GetScoreLine'
      axios
        .get(apiUrl, {
          params: params1,
        }
      ).then(res => {
        this.tableData=res.data.data
        this.query.total=res.data.total
        this.loading=false
      })
      
    },
    xkyqClick() {
      
    },
    handleClick(tab, event) {
      // 清空表单和数据
      // this.activeName='理科'
      // this.query.km = ''
      this.query.page = '1'
      this.query.size='30'
      // this.km1 = []
      this.query.year = this.yearData[0]
      // this.query.type = this.typeData[0]
      // this.query.batch=this.pcData[0]
      // this.query.zymc=''
      // this.query.zkfx=''
      // this.query.bhzy = ''
      // this.query.xkyq = '-1'
      this.tableData = []
      this.query.total = 0
      this.getList()
    },
    changeTwo() {
      if (this.query.km) {
        if (this.km1.length==1) {
          this.query.xkyq='2'
        } else if (this.km1.length==2) {
          this.query.xkyq='3'
        }else if (this.km1.length==0) {
          this.query.xkyq='1'
        }
      } else {
        if (this.km1.length==1) {
          this.query.xkyq='1'
        } else if (this.km1.length==2) {
          this.query.xkyq='2'
        }else if (this.km1.length==0) {
          this.query.xkyq='0'
        }
      }

      
    },
    changeOne(val) {
      // console.log(val,"val");
      if (val) {
        if (this.km1.length==1) {
          this.query.xkyq='2'
        } else if (this.km1.length==2) {
          this.query.xkyq='3'
        }else if (this.km1.length==0) {
          this.query.xkyq='1'
        }
      } else {
        if (this.km1.length==1) {
          this.query.xkyq='1'
        } else if (this.km1.length==2) {
          this.query.xkyq='2'
        }else if (this.km1.length==0) {
          this.query.xkyq='0'
        }
      }
      // this.subjectmax = 3
      // this.query.km = this.query.km.filter((item) => item !== undefined)
      // this.km1 = [val[val.length - 1]]
      // this.query.km = this.query.km.filter(
      //   (item) => !item.includes('物理') && !item.includes('历史')
      // )
      // if (typeof this.km1[0] !== 'undefined') {
      //   this.query.km.push(this.km1[0])
      // } else {
      //   this.subjectmax = 2
      // }
    },
    changeThree() {
      this.query.km = ''
      this.km1=[]
    },
  },
};
</script>
<style lang="scss">
.el-carousel__item {
  width: 75%;
  left: -12.5%;
}
.msgfont {
  font-size: 14px;
  text-align: center;
}
.qrcodediv {
  text-align: center;
  height: 36px;
  line-height: 18px;
  font-size: 12px;
  margin-top: 5px;
}
// 侧栏
.cLine {
  position: fixed;
  left: 100px;
  top: 50%;
  .title {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #313131;
    margin-bottom: 10px;
  }
  .line_item {
    > div,
    .item {
      height: 40px;
      width: 40px;
      border-radius: 20px 20px;
      margin: 10px 0;
      border: 1px solid #154b0e2d;
      background-color: rgba(255, 255, 255, 0.685);
      img {
        width: 20px;
        height: 20px;
        margin: 10px;
      }
    }
  }
  .line_item div:hover,
  .line_item .item:hover {
    cursor: pointer;
  }
}
@media screen and (max-width: 1500px) {
  .cLine {
    left: 5px;
  }
}
@media screen and (max-width: 1320px) {
  .cLine {
    display: none;
  }
}
.titlefont {
  width: 500px;
  text-shadow: 1px 2px 1px pink;
  color: white;
}
:deep(.el-tabs__nav-wrap::after) {
  background-color: #cccccc;
  height: 1px;
}
.mesgList {
  > a {
    display: block;
    height: 35px;
    line-height: 35px;
    margin-bottom: 10px;
  }
}
.stageBoxP {
  padding: 20px 0;
  min-height: 300px;
}
.stageLabel {
  display: inline-block;
  width: 100px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
}
:deep(.el-tabs__active-bar) {
  width: 100px;
}

.boxStage {
  // 大盒子
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; // 替代原先的space-between布局方式
}
.ebox {
  // 每个item
  padding-top: 12px;
  display: block;
  text-align: center;
  flex: 1;
  height: 120px;
  margin: 10px 30px 0px 0; // 间隙为5px
  // background-color: #999;
  width: calc(
    (100% - 200px) / 4
  ); // 这里的10px = (分布个数3-1)*间隙5px, 可以根据实际的分布个数和间隙区调整
  min-width: calc((100% - 100px) / 4); // 加入这两个后每个item的宽度就生效了
  max-width: calc((100% - 100px) / 4); // 加入这两个后每个item的宽度就生效了
  &:nth-child(4n) {
    // 去除第3n个的margin-right
    margin-right: 0;
  }
  .elabel {
    margin-top: 10px;
    height: 20px;
    line-height: 20px;
  }

  div {
    // overflow: hidden;
    :nth-child(1) {
      position: relative;
    }
    :nth-child(2) {
      display: none;
    }
  }
}

.ebox:hover {
  background-color: #567fe6;
  color: white;
  border-radius: 10px;
  font-weight: 600;
  // div {
  //   img {
  //     color: white;
  //   }
  // }
  div {
    :nth-child(1) {
      display: none;
    }
    :nth-child(2) {
      display: block;
      margin: auto;
    }
  }
}

.title_right {
  float: right;
  font-size: 1.1vw;
  height: 50px;
  margin-top: 30px;
  border-radius: 25px 0 0 25px;
  background-color: rgba(255, 255, 255, 0.185);
  width: 200px;
  position: relative;
  > div {
    img {
      height: 38px;
      width: 34px;
      margin: 7px 0 0 15px;
    }
  }
  .title_right_text {
    position: absolute;
    top: 0;
    right: 15px;
    // width: 0px;
    line-height: 50px;
    font-weight: 600;
    font-size: 14px;
  }
}

.bg_skx {
  font-family: "微软雅黑", Arial, "宋体";
  width: 100%;
  padding: 0;
  margin: 0;
  height: 963px !important;
  min-height: 963px;
  background-image: url("../nav/bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 83%;
  background-color: #ffffff;
  .container {
    //   height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    .el-header {
      padding: 0;
      margin: 0;
      height: 320px !important;
      overflow: hidden;
      .header {
        width: 1200px;
        margin: 0 auto;
        color: white;
        > div {
          display: inline-block;
        }
        .logo {
          font-size: 28px;
          font-weight: 600;
          img {
            float: left;
            margin-top: 10px;
          }
          > div {
            width: 400px;
            line-height: 100px;
            padding-left: 80px;
          }
        }
        .nav {
          position: relative;
          top: 10px;
          > div {
            display: inline;
            margin-right: 40px;
            a {
              color: white;
              font-size: 32px;
              font-weight: 600;
            }
          }
        }
      }
    }
    .input_number{
      .el-input-number__decrease{
        display: none;
      }
      .el-input-number__increase{
        display: none;
      }
      input{
        text-align: left;
        padding-left: 10px;
      }
    }
    .el-main {
      width: 100%;
      margin: 0;
      padding: 0;

      .conter {
        margin: 0 auto;
        width: 1200px;
        > .topnav {
          width: 100%;
          height: 45px;
          line-height: 45px;
          border-radius: 2px;
          font-weight: 600;
          background-image: linear-gradient(#579ef8, #568cec, #5785e7);
          display: flex;
          > a {
            display: block;
            color: white;
            flex: 1;
            font-size: 18px;
            text-align: center;
            border-right: 2px solid #ffffff7c;
          }
          a:hover {
            color: #2e76f3;
            background-color: rgb(245, 241, 243);
          }
        }
        .swiper {
          margin: 20px auto;
          border-radius: 5px;
          img {
            width: 100%;
          }
        }
        .cardList {
          clear: both;
          overflow: hidden;
          .left {
            width: 63%;
            float: left;
            .card_item {
              clear: both;
              overflow: hidden;
              height: 180px;
              width: 100%;
              border-top: 8px solid #2e76f3;
              padding: 10px 5px 5px 5px;
              border-radius: 6px;
              background-color: white;
              margin-bottom: 25px;
              box-shadow: 2px 1px 3px 0px rgba(190, 190, 190, 40);
              .card_item_left {
                float: left;
                text-align: center;
                width: 170px;
                height: 100%;
                border-right: 2px solid #2e76f369;
                > div {
                  margin-top: 30px;
                  line-height: 10px;
                  font-size: 20px;
                  font-weight: 600;
                  color: #065acc;
                }
              }
              .card_item_right {
                float: right;
                width: 75%;
                overflow: hidden;
                height: 100%;
                > div {
                  float: left;
                  width: 33%;
                  height: 45%;
                  line-height: 45%;
                  text-align: center;
                  a {
                    font-weight: 400;
                    font-size: 16px;
                  }
                  a:hover {
                    font-weight: 600;
                  }
                }
              }
            }
          }
          .right {
            float: right;
            width: 33%;
            border-top: none;
            .top {
              height: 50px;
              line-height: 50px;
              text-align: center;
              color: white;
              font-weight: 500;
              font-size: 22px;
              background-color: #2e76f3;
              margin-bottom: 6px;
            }
            .down_ks {
              clear: both;
              overflow: hidden;
              > a {
                padding-left: 10px;
                display: block;
                margin-bottom: 6px;
                height: 50px;
                line-height: 50px;
                background-color: #e7f0fd;
                clear: both;
                overflow: hidden;
                > div {
                  //float: left;
                }
                i {
                  color: black !important;
                }
                .rightright {
                  margin-right: 15px;
                  color: #2e76f3;
                  float: right;
                }
              }
              .anone {
                background-color: #c5c3c350;
                color: #6f6f6f;
              }
              .blanka:hover {
                background-color: #8c95ec91;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
    .el-footer {
      overflow: hidden;
      margin: 0;
      padding: 0;
      background-color: #2e76f3;
      height: 50px !important;

      .footer {
        width: 1200px;
        font-size: 12px;
        line-height: 50px;
        text-align: center;
        margin: 0 auto;
        color: white;
        // display: flex;

        // > div {
        //   flex: 1;
        //   padding: 20px 0px;
        //   margin-top: 40px;
        // }
      }
    }
  }
}
.itemhover {
  color: #6f6f6f !important;
}
.itemhover:hover {
  color: #2e76f3;
}
a {
  text-decoration: none;
}
#linkClass {
  color: blue;
}
#linkClass:hover {
  color: #03036f;
  cursor: pointer;
}
.contentBox {
  min-height: 100px;
  color: #4b4b4b;
  line-height: 32px;
  // border: 1px solid #a4a4a45e;
  padding: 10px;
  margin-bottom: 30px;
  background-color: white;
  .title {
    width: 50%;
    margin: 0 auto;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }
  .message {
  }
  .topBox {
    width: 100%;
    text-align: center;
    margin-top: 50px;
  }
}
.flex {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 0px;
  justify-content: space-between;
}
.posibox {
  // position: relative;
  // top: 20px;
  // right: 20px;
}
#bgcolor {
  color: blue;
  cursor: pointer;
}
.message {
  .hljs-center {
    text-align: center !important;
  }
  .hljs-left {
    text-align: left !important;
  }
  .hljs-right {
    text-align: right !important;
  }
  pre {
    padding: 16px;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    background-color: #f6f8fa;
    border-radius: 3px;
    code {
      display: inline;
      max-width: auto;
      padding: 0;
      margin: 0;
      overflow: visible;
      line-height: inherit;
      word-wrap: normal;
      background-color: transparent;
      border: 0;
    }
  }
  table {
    display: block;
    width: 100%;
    overflow: auto;
    margin-top: 0;
    margin-bottom: 16px;
    border-spacing: 0;
    border-collapse: collapse;
    width: 100% !important;
    th {
      border: 1px solid #ccc !important;
      font-weight: 600;
      padding: 6px 13px;
    }
    td {
      border: 1px solid #ccc !important;
      padding: 6px 13px;
    }
  }
}
.bg_skx{
  .el-radio__input{
        display: none;
      }
  .flex_item{
    margin-top: -2px;
  }
  .el-radio-group{
    .el-radio{
      margin-right: 19px;
    }
  }
  .flex100{
    // display: flex;
    // align-items: center;
    margin-bottom: 6px;
    .el-form-item__label,.el-form-item__content{
      line-height: 37px;
    }
    .el-form-item__label{
      font-size: 15px;
    }
  }

  .contentBox{
    border: 0px !important;
    .el-tabs__item{
      font-size: 19px;
    }
  }
  .line_box{
    // width: 100%;
    padding: 10px 20px 0;
    padding-bottom: 0px;
    border: 1px solid #eee;
    .el-form-item__content{
      .el-input{
        height: 36px;
        line-height: 36px;
      }
    }
  }
  .button_click{
    border-radius: 6px;
    margin-top: 5px;
    width: 63px;
    height: 28px;
    color: rgb(255, 255, 255);
    background: #409EFF;
    border: 1px solid #409EFF;
    font-size: 14px;
    cursor: pointer;
  }
  .filiter{
    .year_box{
      width: 100px;
    }
    padding-bottom: 13px;
    position: relative;
    .year_box::after{

    }
  }
  .title_xk{
    font-size: 20px;
    font-weight: 600;
    // text-align: center;
    margin: 20px 0;
  }
  .line-gray{
    // background-color: #EDEDED;
    height: 12px;
  }
  .pagination_box{
    margin-top: 20px;
    text-align: center;
    .el-pager{
      li{
        // border-radius: 50%;
        margin-left: 10px;
      }
    }
  }

  .el-table{
    thead{
        > tr{
          >th{
            background-color: #FAFAFA;
            font-weight: 700;
            color: #13161B;
          }
        }
      }
  }
  .yxlxdm{
    .el-form-item__label{
      padding-right: 17px;
    }
  }
  .menu-box1180{
      width: 1200px;
      margin: 0 auto;
      padding: 0;
      // background: #fff;
      border-radius: 11px;
      overflow: hidden;
      margin-top: 100px;
      // background: #fff;
      border-radius: 11px;
      .box1180_ul{
        display: flex;
        align-items: center;
        list-style: none;
        // margin-top: 177px;
        padding: 0;
        margin-top: 10px;
        justify-content: space-between;
        height: 100px;
        background-color: white;
        border-radius: 12px;
        li{
          width: 25%;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          .noshowImg{
            display: block;
          }
          .showImg{
            display: none;
          }
          img {
            width: 61px !important;
            height: 60px !important;
            margin-right: 5px;
          }
          span {
            width: 100%;
            font-size: 22px;
            display: flex;
            justify-content: center; /* 水平居中 */
            align-items: center; /* 垂直居中 */
          }
        }
        li:hover{
          color: #409EFF;
          font-weight: bold;
          .showImg{
            display: block;
          }
          .noshowImg{
            display: none;
          }
        }
        li:nth-child(1){
          // border-top-right-radius: 0px;
          // border-bottom-right-radius: 0px;
        }
        li:nth-child(2){
          // border-right: 2px solid #409EFF;
          // border-top-right-radius: 0px;
          // border-bottom-right-radius: 0px;
          // border-top-left-radius: 0px;
          // border-bottom-left-radius: 0px;
        }
        li:nth-child(3){
          color: #409EFF;
          font-weight: bold;
          .showImg{
            display: block;
          }
          .noshowImg{
            display: none;
          }
          // border-top-left-radius: 0px;
          // border-bottom-left-radius: 0px;
        }
        .active_li{
          // background-color: #409EFF;
          // color: white;
        }
        li>p{
          margin: 0;
        }
      }
  }
  .tab_boxpaolu{
    width: 1200px;
    margin: 0 auto;
  }
}
</style>
  
  
  <style lang="scss" >
  .div_bottom_fixed{
    // background-color: red;
    height: 50px;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    display: none;
    align-items: center;
    justify-content: space-around;
    background-color: white;
    border-top: 1px solid #00000047;
    z-index: 999;
    .box{
      width: 20%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000000b5;
      flex-direction: column;

    }
    .active_box_bar{
      color: #409EFF;
    }
  }
  //  我宣布，这里就是兼容移动端的css代码，屎山开始堆积
  @media screen and (max-width: 600px) {
    .bg_skx{
      height: auto;
      min-height: auto;
         // 新增筛选   我自己都看着和屎一样
         .block_span{
        display: inline-block !important;
      }
      .title_xk{
        margin-top:0px;
      }
      .el-drawer__header{
        margin-bottom: 0px;
        padding-top: 7px;
        padding-right: 6px;
        .el-drawer__close-btn{
          position: relative;
          z-index: 999;
        }
      }
      .el-form{
        display: none !important;
        padding-left: 10px;
      }
      .flex100{
        margin-bottom: 0px !important;
      }
      .flex100_draw{
        .el-checkbox{
          margin-right: 6px;
        }
      
      }

      .el-checkbox__label{
        padding-left: 5px;
      }
      .el-header{
          display:none;
          .header{
              display: none;
          }
      }
      .yxlxdm{
        .el-form-item__label{
          padding-right: 13px !important;
        }
      }
      .flex100_draw{
        >.el-form-item__content{
          >.el-checkbox-group{
            margin-left: -5px;
          }
        }
      }
      .el-drawer__body{
        position: relative;
        margin-top: -19px;
        .button_click{
          position: absolute;
          right:10px;
          bottom:10px;
        }
        .el-form{
          height: 75%;
          overflow-y: scroll;
          .xuankaoyaoqiu{
            .el-radio-group{
              padding-left: 8px !important;
            }
            .el-radio{
                margin-right:5px !important;
                .el-radio__label{
                  padding-left: 2px !important;
                }
              }
            .el-form-item__label{
              padding-right: 3px !important;

            }
          }

        }
        
      }
      .pici_box{
            .el-form-item__label{
              width: 44px !important;
              line-height: 13px;
            }
            .el-form-item__content{
              flex: 1 !important;
            }
            .el-radio{
              margin-bottom: 9px !important;
            }
          }
      // 新增筛选
      .el-header{
          display:none;
          .header{
              display: none;
          }
      }
      .menu-box1180{
          width: 100%;
          .box1180_ul{
              margin-top: 0px;
              li{
                  height: 40px;
                  line-height: 40px;
                  font-size: 17px;
              }

          }
      }

      .el-main{
          overflow: hidden !important;
          margin-top: 0px  !important;
          .conter{
            width: 100% !important;
          }
      }
    }
    .el-footer{
       visibility: hidden !important;
    }
    .footer{
      width:100% !important;
    }
    .pagination_box{
      overflow: auto !important;
      margin-bottom:20px !important;
    }
    .bg{
      height: 100vh !important;
      overflow: hidden !important;
      min-height:0px !important;
      .bg_skx{
          height: 100vh !important;
          overflow: hidden !important;
          min-height:0px !important;
          .el-container{
              height: 100vh !important;
              display: flex !important;
              flex-direction: column !important;
              .el-main{
                  flex: 1 !important;
                  .conter{
                      height: 100% !important;
                      .contentBox{
                          height: 100%;
                          display: flex;
                          flex-direction: column;
                      }
                  }
              }
          }
      }
    }
    .div_bottom_fixed{
      display: flex !important;
    }
  }
  .bg_skx{
    .logo{
      position: relative;
      top: 30px;
      left: 344px;
      font-size: 77px !important;
    }
    .titlefont{
      width: 900px;
      font-size: 5rem;
    font-weight: bold;
    color: #fff;
    text-shadow: 0 0 5px #ffffff30, 0 0 10px #fff, 0 0 20px #000000, 0 0 40px #00000000, 0 0 80px #0000002e;
    font-family: cursive;
    }
  }
</style>
